import { SectionHeading } from './SectionHeading'

const press = [
  {
    outlet: 'ワニブックス NewsCrunch',
    title: '「お絵描きばりぐっどくん」開発者インタビュー（友達登録240万人超）',
    date: '2023.03',
    href: 'https://wanibooks-newscrunch.com/articles/-/4073'
  },
  {
    outlet: 'ITmedia NEWS',
    title: '画像生成LINE Bot「お絵描きばりぐっどくん」を紹介',
    date: '2022.08',
    href: ''
  },
  {
    outlet: 'ねとらぼ',
    title: '画像生成LINE Bot「お絵描きばりぐっどくん」を紹介',
    date: '2022.08',
    href: ''
  },
  {
    outlet: '西日本新聞',
    title: '防災アプリ「MAPCHAIN」、国内最大級イベントで特別賞を受賞',
    date: '2021.12',
    href: 'https://www.nishinippon.co.jp/item/847110/'
  },
  {
    outlet: '九州工業大学 NEWS',
    title: 'Yahoo! JAPAN「Digital Hack Day 2021」で特別賞を受賞',
    date: '2021',
    href: 'https://www.kyutech.ac.jp/whats-new/topics/entry-8633.html'
  },
  {
    outlet: '九州工業大学 NEWS',
    title: '「SAI ZEN SEN for tech 2021 SUMMER」に登壇',
    date: '2021',
    href: 'https://www.kyutech.ac.jp/whats-new/topics/entry-8450.html'
  }
]

// 「お絵描きばりぐっどくん」のテレビ・YouTube出演（2022年）
const tv = [
  {
    date: '2022',
    program: 'YouTube「HIKAKIN」『AIにYouTuber描かせたら鳥肌たった…』',
    href: 'https://youtu.be/7zLKwbbzJuQ'
  },
  { date: '2022.08.31', program: 'フジテレビ「めざましテレビ」', href: '' },
  { date: '2022.08.31', program: 'TBS「THE TIME,」', href: '' },
  { date: '2022.09.08', program: 'TBS「ひるおび」', href: '' },
  { date: '2022.09.10', program: '読売テレビ「あさパラS」', href: '' },
  {
    date: '2022.09.23',
    program: 'YouTube「ジャニーズJr.チャンネル」',
    href: ''
  },
  { date: '2022.09.25', program: 'フジテレビ「ワイドナショー」', href: '' },
  { date: '2022.09.30', program: 'RKB毎日放送「タダイマ！」', href: '' },
  { date: '2022.10', program: 'テレビ朝日「報道ステーション」', href: '' },
  { date: '2022.11.07', program: 'NHK「あさイチ」', href: '' },
  { date: '2022.12.09', program: 'TBS「Nスタ」', href: '' }
]

export const Media = () => {
  return (
    <section id="media" className="py-12 border-t border-ink-100">
      <SectionHeading number="04" title="メディア掲載" />
      <div className="space-y-10">
        <div>
          <h3 className="mb-4 text-base font-semibold text-ink-800">記事</h3>
          <ul className="space-y-6">
            {press.map(({ outlet, title, date, href }) => {
              const heading = href ? (
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-ink-800 underline decoration-ink-400/30"
                >
                  {title}
                  <span className="sr-only">
                    （外部サイト、新しいタブで開く）
                  </span>
                </a>
              ) : (
                <span className="text-ink-800">{title}</span>
              )

              return (
                <li
                  key={`${outlet}-${title}`}
                  className="grid gap-1 sm:grid-cols-[8rem_1fr] sm:gap-6"
                >
                  <div className="font-mono text-xs tabular-nums tracking-wider text-ink-600 pt-[3px]">
                    {date}
                  </div>
                  <div>
                    <div className="font-mono text-xs tracking-wider text-ink-600">
                      {outlet}
                    </div>
                    <p className="mt-1 text-base leading-[1.9]">{heading}</p>
                  </div>
                </li>
              )
            })}
          </ul>
        </div>

        <div>
          <h3 className="mb-1 text-base font-semibold text-ink-800">
            テレビ・YouTube出演
          </h3>
          <p className="mb-4 text-sm leading-[1.8] text-ink-500">
            「お絵描きばりぐっどくん」が全国の番組・チャンネルで紹介されました（2022年）。
          </p>
          <ul className="space-y-2.5">
            {tv.map(({ date, program, href }) => (
              <li
                key={`${date}-${program}`}
                className="grid gap-1 sm:grid-cols-[8rem_1fr] sm:gap-6"
              >
                <div className="font-mono text-xs tabular-nums tracking-wider text-ink-600">
                  {date}
                </div>
                <div className="text-base leading-[1.7] text-ink-800">
                  {href ? (
                    <a
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="underline decoration-ink-400/30"
                    >
                      {program}
                      <span className="sr-only">
                        （外部サイト、新しいタブで開く）
                      </span>
                    </a>
                  ) : (
                    program
                  )}
                </div>
              </li>
            ))}
          </ul>
          <p className="mt-4 text-sm leading-[1.8] text-ink-500">
            ほか、TBS「ラヴィット！」などでも紹介されました。
          </p>
        </div>
      </div>
    </section>
  )
}
